export default __webpack_public_path__ + "static/media/lovrican-white.5f25516e.svg";